import axiosInstance from './axiosInstance';

export const createRazorpayOrder = async (orderId) => {
  try {
    const response = await axiosInstance.post('/payments/razorpay/order', { orderId });
    return response.data;
  } catch (error) {
    console.error('Error creating Razorpay order:', error);
    throw error;
  }
};

export const verifyRazorpayPayment = async (paymentData) => {
  try {
    const response = await axiosInstance.post('/payments/razorpay/verify', paymentData);
    return response.data;
  } catch (error) {
    console.error('Error verifying Razorpay payment:', error);
    throw error;
  }
};